import type { CartSku, ProductDeliveryVariant, StoreService } from '@common/contracts/server/ostin/api';

import { yyyymmdd } from '@/utils/date/date-to-string';

export interface IVariantInterval {
  id: string;
  dateFrom: string;
  dateTo: string;
  time: IVariantIntervalsTime[];
  needPrepay?: boolean,
  services?: StoreService[],
}

export interface IVariantIntervalsTime {
  selected: boolean;
  skus: CartSku[];
  value?: string;
  id?: string;
  productCount?: number;
  freeShipping?: boolean;
  shippingPrice?: string;
}

/**
 * Функция вынесена из store/cart.js - с целью в дальнейшем отказаться от этого стора не ломая работу приложения.
 */
export function fromDeliveryVariantsToIntervals(
  deliveryVariants: ProductDeliveryVariant[],
  selectedIntervalId = '',
) {
  const intervalMap = new Map<string, IVariantInterval>();

  for (let i = 0; i < deliveryVariants.length; i++) {
    const variant = deliveryVariants[i];
    const dateFrom = yyyymmdd(new Date(variant.deliveryDateFrom || '') || '', '-');
    const dateTo = variant.deliveryDateTo ? yyyymmdd(new Date(variant.deliveryDateTo), '-') : '';

    let key = dateFrom;
    if (dateTo) {
      key += `:::${dateTo}`;
    }

    const intervalTime: IVariantIntervalsTime = {
      selected: selectedIntervalId ? selectedIntervalId === variant.intervalTimeId : i === 0,
      value: variant.intervalTime,
      id: variant.intervalTimeId,
      productCount: variant.productCount,
      freeShipping: variant.freeShipping,
      shippingPrice: variant.shippingPrice,
      skus: variant.skus || [],
    };

    if (!intervalMap.has(key)) {
      intervalMap.set(key, {
        id: key,
        dateFrom,
        dateTo,
        time: [],
        needPrepay: variant.needPrepay,
        services: variant.services,
      });
    }

    intervalMap.get(key)?.time.push(intervalTime);
  }

  return Array.from(intervalMap.values());
}
